import { Base64 } from "js-base64";

export const generateRandomStateToken = (bytesOfEntropy: number): string => {
	const arr = new Uint8Array(bytesOfEntropy);
	crypto.getRandomValues(arr);

	return Base64.fromUint8Array(arr, true);
};
